$(function () {

    const padEnquiryFooter = () => {
        $("#enquiry-popup #enquiry-popup-list").css({ "paddingBottom": $("#enquiry-popup #enquiry-footer-inner").outerHeight() + 35 })
    }

    //Function to toggle login/register dropdown
    //By default, register will show
    const toggleLoginRegister = (register = true) => {

        //Register dropdown should be toggled
        if (register) {
            $(".signin__dropdown#sign-in").slideUp(250, () => {
                $(".signin__dropdown#register").slideDown(); 
            })              
        } else {
            $(".signin__dropdown#register").slideUp(250, () => {
                $(".signin__dropdown#sign-in").slideDown(); 
            })  
        }

        //Close mobile menu if open
        if ($("body").hasClass("menu-open")) {
            $("body").removeClass("menu-open")
        }

    }

    padEnquiryFooter();
    $(window).on("resize", padEnquiryFooter)    

    $(".mobile__nav__toggle button").on("click", function () {
        $("body").toggleClass("menu-open");
    });

    $(".close-menu").on("click", function () {
        $("body").toggleClass("menu-open");

        $(".l0__mobile__toggle.open").removeClass("open")
        $(".l0__mobile.open").removeClass("open");
        $(".mobile__menu__sub.open").removeClass("open")
    })

    function mobileToggle_Depth_0(menuToggleButton) {
        let menuItem = menuToggleButton.closest('.has-children');
        let menuItemDropdownMenu = menuItem.querySelector('.l0__mobile__links');
        if(menuItem.classList.contains('toggled')){ // Menu item is already toggled
            menuItem.classList.remove('toggled');
            menuItemDropdownMenu.style.maxHeight = null;
        }else{ // Menu item is currently closed
            menuItem.classList.add('toggled');
            menuItemDropdownMenu.style.maxHeight = "calc(" + menuItemDropdownMenu.scrollHeight + "px)";
        }
    }    
    const mobileItems_Depth_0 = document.querySelectorAll(".mobile-toggle_depth_0");
    for (let i = 0; i < mobileItems_Depth_0.length; i++) {
        mobileItems_Depth_0[i].addEventListener("click", () => { mobileToggle_Depth_0(mobileItems_Depth_0[i]); }, false);
    }


    function mobileToggle_Depth_1(menuItem) {
        let targetSubMenuAttr = menuItem.dataset.menuTarget;
        const subMenu = document.querySelector(`.mobile__menu__sub[data-menu-primary="${targetSubMenuAttr}"]`);
        subMenu.classList.add("open");
    }
    const mobileItems_Depth_1 = document.querySelectorAll(".mobile-toggle_depth_1");
    for (let i = 0; i < mobileItems_Depth_1.length; i++) {
        mobileItems_Depth_1[i].addEventListener("click", () => { mobileToggle_Depth_1(mobileItems_Depth_1[i]); }, false);
    }


    function mobileToggle_Depth_2(menuItem) {
        let targetSubMenuAttr = menuItem.dataset.menuTarget;
        const subMenu = document.querySelector(`.mobile__menu__sub.child[data-menu-secondary="${targetSubMenuAttr}"]`);
        subMenu.classList.add("open");
    }   
    const mobileItems_Depth_2 = document.querySelectorAll(".mobile-toggle_depth_2");
    for (let i = 0; i < mobileItems_Depth_2.length; i++) {
        mobileItems_Depth_2[i].addEventListener("click", () => { mobileToggle_Depth_2(mobileItems_Depth_2[i]); }, false);
    }


    $(".mobile__sub__prev").on("click", function () {
        const clickedIndex = $(this).index(".menu__sub__prev");
        $(this).closest(".mobile__menu__sub.open").removeClass("open")
    })
    
    //Enquiry popup
    $(".top__nav a.enquiry-list, #top-links-mobile a.enquiry-list").on("click", function () {
        $("body").toggleClass("enquiry-open");
        $("#enquiry-popup").toggleClass("open");
    })

    $("#close-enquiry-popup").on("click", function () {
        $("body").removeClass("enquiry-open");
        $("#enquiry-popup").removeClass("open");
    });

    $("#enquiry-popup-list li .enquiry-list--remove").on("click", function () {
        let index = $(this).index("#enquiry-list--remove");
        $("#enquiry-popup-list li").eq(index).remove();
    });

    $(".enquiry-list-clear").on("click", function () {
        $("#enquiry-popup-list li").remove();
        $(this).hide();
    });

    //Sign-in / register dropdown
    $("a span").on("click", function () {
        if ($(this).text().toLowerCase().includes("sign-in")) {                    
            toggleLoginRegister(false);            
        } else if ($(this).text().toLowerCase().includes("register")) {        
            toggleLoginRegister(true);            
        }
    });

    //Handle sign-in click
    $(".signin__dropdown h3 > span").on("click", function () {

        if ($(this).attr("id") === "sign-in-toggle") {
            toggleLoginRegister(false)
        } else {
            toggleLoginRegister(true)
        }

    })

    $(".close-signin").on("click", () => $(".signin__dropdown").slideUp())

})


// Fetch all the details element.
const details = document.querySelectorAll("details");

for (let i = 0; i < details.length; i++) {
    details[i].addEventListener("click", () => {
        let targetDetail = event.currentTarget;
        // Close all the details that are not targetDetail.
        for (let i = 0; i < details.length; i++) {
            if (details[i] !== targetDetail) {
                details[i].removeAttribute("open");
            }
        }
    });
}


let timer;

function openSubMenu(menuItem) {
    const sub_menu = menuItem.querySelector('.sub-menu');
    const sub_menu_toggle = menuItem.querySelector('.dropdown-toggle');

    menuItem.classList.add('toggled');

    sub_menu.setAttribute('aria-expanded', "true");
    sub_menu.classList.add('toggled');

    sub_menu_toggle.setAttribute('aria-expanded', "true");
    sub_menu_toggle.classList.add('toggled');
}

function closeSubMenu(menuItem) {
    const sub_menu = menuItem.querySelector('.sub-menu');
    const sub_menu_toggle = menuItem.querySelector('.dropdown-toggle');

    menuItem.classList.remove('toggled');

    sub_menu.setAttribute('aria-expanded', "false");
    sub_menu.classList.remove('toggled');

    sub_menu_toggle.setAttribute('aria-expanded', "false");
    sub_menu_toggle.classList.remove('toggled');
}

function toggleSubMenu(e) {
    e.stopPropagation();
    const menuItem = e.currentTarget.parentNode;
    const subMenu = menuItem.querySelector('.sub-menu');
    const toggled = document.querySelectorAll('#site-menu .toggled');

    if(menuItem.classList.contains('toggled')){
        menuItem.classList.remove('toggled');
    }else{
        for (let i = 0; i < toggled.length; i++) {
            toggled[i].classList.remove('toggled');
        }
        menuItem.classList.add('toggled');
    }

    if(subMenu.classList.contains('toggled')){ //If the menu is already toggled...
        e.target.classList.remove('toggled');
        e.target.setAttribute('aria-expanded', "false");
        subMenu.classList.remove('toggled');
    }else{ // If the submenu isnt toggled...
        for (let i = 0; i < toggled.length; i++) {
            toggled[i].classList.remove('toggled');
        }
        e.target.classList.add('toggled');
        e.target.setAttribute('aria-expanded', "true");
        subMenu.classList.add('toggled');
    }
}

function mouseoverToggle(e) {
    
        const menuItem = this;
        const toggled = document.querySelectorAll('#site-menu .toggled');
        for (let i = 0; i < toggled.length; i++) {
            toggled[i].classList.remove('toggled');
        }
        openSubMenu(menuItem);
        clearTimeout(timer); //reset the timeout used below on mouseout
    
}

function mouseoutToggle(e) {
    const menuItem = this;
    timer = setTimeout(function(){ //Set a timeout to accomodate any mouse inaccuracies from users
        closeSubMenu(menuItem);
        const toggled = document.querySelectorAll('#site-menu .toggled');
        for (let i = 0; i < toggled.length; i++) {
          toggled[i].classList.remove('toggled');
        }
    }, 650);
}


const menuItemsWithChildren = document.querySelectorAll('.menu-item.has-children');

for (let i = 0; i < menuItemsWithChildren.length; i++) {
    const dropdownToggle = menuItemsWithChildren[i].querySelector('.dropdown-toggle');
    dropdownToggle.addEventListener("click", toggleSubMenu, false);

    const highlightFocusable = menuItemsWithChildren[i].querySelectorAll('a');

    const lastFocusableEl = highlightFocusable[highlightFocusable.length - 1];

    lastFocusableEl.addEventListener('keydown', function handleTabOff(e) {
        if (!e.shiftKey && e.keyCode === 9) {
            closeSubMenu(menuItemsWithChildren[i]);
        }
    });

    
    if (window.innerWidth > 950){
        menuItemsWithChildren[i].addEventListener("mouseover", mouseoverToggle, false);
        menuItemsWithChildren[i].addEventListener("mouseout", mouseoutToggle, false);
    }
    window.addEventListener("resize", function() {
        if (window.innerWidth > 950){
            menuItemsWithChildren[i].addEventListener("mouseover", mouseoverToggle, false);
            menuItemsWithChildren[i].addEventListener("mouseout", mouseoutToggle, false);
        } else if (window.innerWidth < 950){
            menuItemsWithChildren[i].removeEventListener("mouseover", mouseoverToggle, false);
            menuItemsWithChildren[i].removeEventListener("mouseout", mouseoutToggle, false);
        }
    });
}

//Listen for clicks outside of the toggled submenu, and close the menu if found
document.addEventListener('click', function handleClickOutsideBox(event) {
    const openMenuItem = document.querySelector('.menu-item.toggled');
    if (typeof(openMenuItem) != 'undefined' && openMenuItem != null) {
        if (!openMenuItem.contains(event.target)) {
            openMenuItem.querySelector('.dropdown-toggle.toggled').setAttribute('aria-expanded', "false");
            openMenuItem.querySelector('.dropdown-toggle.toggled').classList.remove('toggled');
            openMenuItem.classList.remove('toggled');
            openMenuItem.querySelector('.sub-menu').classList.remove('toggled');
        }
    }
});

const siteMenu = document.querySelector('#site-menu');
const menuFocusableElements = ['input' , 'button' , '[href]', 'select', 'textarea', '[tabindex]:not([tabindex="-1"])'];
let firstFocusableMenuElement = siteMenu.querySelectorAll(menuFocusableElements)[0];
let focusableMenuContent =  siteMenu.querySelectorAll(menuFocusableElements);
let lastFocusableMenuElement = siteMenu[focusableMenuContent.length - 1];

document.addEventListener('keydown', function(e) {
    if(siteMenu.classList.contains('toggled')){
        let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

        let isEscPressed = e.key === 'Escape' || e.keyCode === 27;

        if(isEscPressed){
            closeMobileMenu();
        }
        
        if (!isTabPressed) {
            return;
        }
        
        if (e.shiftKey) { // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableMenuElement) {
                mobileMenuToggle.focus();
                e.preventDefault();
            }
        } else { // if tab key is pressed
            if (document.activeElement === mobileMenuToggle) {
                firstFocusableMenuElement.focus();
                e.preventDefault();
            }
        }
    }
});